import { Chip } from "@mui/material";

interface Props {
    status: string;
}

const StatusChip = ({ status }: Props) => {
    const statusColors: Record<string, { backgroundColor: string; color: string, fontWeight: string }> = {
        Return: { backgroundColor: '#f8f8f8', color: '#7A4100', fontWeight: 'bold' },
        Delivered: { backgroundColor: '#C4EAFF', color: '#7A4100', fontWeight: 'bold' },
        Failed: { backgroundColor: '#FFB1BB', color: '#7A4100', fontWeight: 'bold' },
    };

    const colorConfig = statusColors[status] || { backgroundColor: '#FF563029', color: '#B71D18' };

    return (
        <Chip
            style={{
                backgroundColor: colorConfig.backgroundColor,
                color: colorConfig.color,
                borderRadius: '5px',
            }}
            label={status}
        />
    );
};

export default StatusChip;
